<template>
  <div class="d-flex justify-content-end align-items-center">
    <PfDescriptionColumn
        ref="descriptionColumn"
        :row="row"
        :index="index"
        :datatable="datatable">
    </PfDescriptionColumn>
  </div>
</template>

<script>

import Vue from 'vue'
import toastr from "toastr";
import PfDescriptionColumn from "../components/pf-description-column";

export default Vue.extend({
  components: {PfDescriptionColumn},
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  data() {
    return {
      data: {},
      loading: false,
      isError: false
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
})

</script>